export default __webpack_public_path__ + "static/media/group.3eda833f.png";